import React from 'react';

import CloseSvg from './assets/close.svg';

export const Close = () => (
  <div>
    <img src={CloseSvg} alt="SVG Icon" />
  </div>
);
